下游付款
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
      <span>
        {{ isThirdPartyContractor ? '下游收款流程' : '付款申请流程' }}
      </span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 付款申请信息 -->
      <div class="back-color-fff mt-4">
        <span class="form-title">付款方相关信息</span>
        <el-form :model="formData" :rules="formRules" ref="formData">
          <el-row :gutter="24">
            <el-col :span="9">
              <el-form-item style="width: 100%" label-width="122px">
                <span slot="label" style="color: red">*</span>
                <span slot="label">是否转包任务：</span>
                <el-select
                  class="fl"
                  style="width: 100%"
                  v-model="formData.isChangeService"
                  placeholder="请选择"
                  filterable
                  @change="changeService"
                >
                  <el-option v-for="item in getCodeListByKey('是否')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="15">
              <el-form-item label-width="122px" prop="relevance">
                <span slot="label"> 
                  <span style="color: red" v-show="formData.isChangeService == 'N'">*</span>
                  关联流程： 
                </span>
                <el-input
                  style="width: 100%"
                  v-model="formData.relevance"
                  placeholder="请选择关联流程"
                  readonly
                  @focus="focusRelevance"
                >
                  <i
                    v-if="formData.relevance"
                    slot="suffix"
                    class="el-input__icon el-icon-circle-close"
                    role="button"
                    tabindex="0"
                    aria-label="清除关联流程"
                    title="清除关联流程"
                    style="cursor: pointer; color: #606266; font-size: 16px"
                    @mousedown.stop.prevent
                    @click.stop="clearSelectedFlow"
                    @keydown.enter.stop.prevent="clearSelectedFlow"
                    @keydown.space.stop.prevent="clearSelectedFlow"
                  ></i>
                </el-input>
                <!-- <span v-if="formData.relevance" class="file-preview" @click="seeDetail">查看详情</span> -->
              </el-form-item>
            </el-col>
            <!-- 核算月：垫资路径治本。非转包关联流程必选→恒带出只读；转包未关联流程时可填且必填 -->
            <el-col :span="9">
              <el-form-item style="width: 100%" label-width="122px">
                <span slot="label">
                  <span style="color: red" v-show="!accountMonthDisabled">*</span>
                  核算月：
                </span>
                <el-date-picker
                  v-if="!accountMonthDisabled"
                  v-model="accountMonthPick"
                  type="month"
                  value-format="yyyyMM"
                  placeholder="请选择核算月"
                  style="width: 100%"
                  :clearable="false"
                  @change="onAccountMonthPick"
                >
                </el-date-picker>
                <el-input
                  v-else
                  :value="accountMonthText"
                  readonly
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="15" v-if="formData.isChangeService == 'Y'">
              <el-form-item label-width="122px" prop="operationReportGuid">
                <span slot="label">关联运营报告： </span>
                <el-input
                  v-model="formData.operationReportName"
                  placeholder="请选择关联运营报告"
                  readonly
                  @focus="focusOperationReport"
                  style="width: 100%;"
                >
                  <i
                    v-if="formData.operationReportGuid"
                    slot="suffix"
                    class="el-input__icon el-icon-circle-close"
                    role="button"
                    tabindex="0"
                    aria-label="清除关联运营报告"
                    title="清除关联运营报告"
                    style="cursor: pointer; color: #606266; font-size: 16px"
                    @mousedown.stop.prevent
                    @click.stop="clearSelectedReport"
                    @keydown.enter.stop.prevent="clearSelectedReport"
                    @keydown.space.stop.prevent="clearSelectedReport"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" v-if="formData.isChangeService == 'Y'">
              <el-form-item style="width: 100%" label-width="122px">
                <span slot="label">
                  <span style="color: red">*</span>药企名称：
                </span>
                <el-select
                  v-model="formData.operationReportTenantGuid"
                  placeholder="请选择企业"
                  style="width: 100%"
                  filterable
                  @change="changeOperationReportTenant"
                >
                  <el-option
                    v-for="item in serviceTenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="15" v-show="formData.payBankInfoList.length == 1 || formData.isChangeService == 'Y'">
              <el-form-item label-width="122px">
                <span slot="label"> <span style="color: red">*</span>付款方： </span>
                {{ detailData.serviceTenantName || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="9" v-show="formData.payBankInfoList.length == 1 || formData.isChangeService == 'Y'">
              <el-form-item style="width: 100%" prop="payBankName" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>付款开户银行： </span>
                <el-select
                  :value="formData.payBankInfoList[0]?.payBankName"
                  placeholder="请选择付款开户银行"
                  style="width: 100%"
                  filterable
                  @change="payBankNameChange"
                >
                  <el-option v-for="item in payBankList" :key="item.guid" :label="item.bankName" :value="item.bankName">
                    <span style="float: left">{{
                      `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType, '账户类型')}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="15" v-show="formData.payBankInfoList.length == 1 || formData.isChangeService == 'Y'">
              <el-form-item label-width="122px">
                <span slot="label"> <span style="color: red">*</span>付款银行账户： </span>
                  {{  formData.payBankInfoList[0]?.payBankAccount || '-' }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" v-show="formData.payBankInfoList.length > 1">
            <el-col :span="8">
              <el-form-item prop="payBankName" label-width="122px">
              <span slot="label"> <span style="color: red">*</span>付款方： </span>
                {{ detailData.serviceTenantName || '-' }}
              </el-form-item>
            </el-col>
          </el-row>

          <div
            v-show="formData.payBankInfoList.length > 1" 
            v-for="(item, index) in formData.payBankInfoList"
            :key="item.taskTypeGuid"
          >
            <div class="form-title-item"> 任务大类 {{ index + 1 }} </div>

            <el-row :gutter="24" >

              <el-col :span="8">
                <el-form-item label="" label-width="122px">
                  <span slot="label"> <span style="color: red">*</span>任务大类： </span>
                  {{ item.taskType || '-' }}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="" label-width="122px">
                  <span slot="label"> <span style="color: red">*</span>开票金额(元)： </span>
                 {{ item.totalAmount || '-' }}
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24" >
              <el-col :span="8">
                <el-form-item prop="payBankName" label-width="122px">
                  <span slot="label"> <span style="color: red">*</span>付款开户银行： </span>
                  <el-select
                    v-model="item.payBankName"
                    placeholder="请选择付款开户银行"
                    filterable
                    @change="(value) => payBankNameChange(value,index)"
                  >
                    <el-option 
                      v-for="item in payBankList" 
                      :key="item.guid" 
                      :label="item.bankName" 
                      :value="item.bankName"
                    >
                      <span style="float: left">{{
                        `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType, '账户类型')}`
                      }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="122px">
                  <span slot="label"> <span style="color: red">*</span>付款银行账户： </span>
                  {{ item.payBankAccount || '-' }}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="" label-width="122px">
                  <span slot="label"> <span style="color: red">*</span>付款金额(元)： </span>
                  <el-input
                    disabled
                    type="text"
                    @input="(value)=>onChangePayAmountItem(value,item,index)"
                    :value="item.payAmount"
                    placeholder="请填写付款金额"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>



          <!-- <el-row
            :gutter="24"
            v-show="detailData.settleDetail?.length > 1"
          >
            <el-col :span="24" :offset="1">
              <el-form-item>
                <a class="txt-color" @click="addPayBank"> 
                  {{ formData.payBankInfoList.length == 1 ? '+ 添加多个付款银行' : '- 取消添加多个付款银行'  }}
                </a>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <!-- end of 付款申请信息 -->

      <!-- 收款方信息 -->
      <div class="back-color-fff mt-4 pb60">
        <span class="form-title">收款方及其他信息</span>
        <el-form :model="formData" :rules="formRules" ref="formData">

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label-width="122px" prop="receiveTenantGuid">
                <span slot="label"> <span style="color: red">*</span>收款方： </span>
                <el-select
                  v-if="formData.isChangeService == 'Y' && !formData.relevance"
                  v-model="formData.receiveTenantGuid"
                  placeholder="请选择收款方"
                  filterable
                  @change="onReceiveTenantChange"
                >
                  <el-option 
                    v-for="item in threeServiceList" 
                    :key="item.sendTenantGuid" 
                    :label="item.sendTenantName" 
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select>
                <span v-else>{{ detailData.tenantName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="receiveBankName" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>收款开户银行： </span>
                <el-select
                  v-model="formData.receiveBankName"
                  placeholder="请选择收款开户银行"
                  filterable
                  @change="reciveBankNameChange"
                >
                  <el-option v-for="item in receiveBankList" :key="item.guid" :label="item.bankName" :value="item.guid">
                    <span style="float: left">{{
                      `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType, '账户类型')}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="receiveBankAccount" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>收款银行账户： </span>
                {{ formData.receiveBankAccount || '-' }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8" style="margin-left: -18px;">
              <el-form-item prop="payTime" label-width="140px">
                <span slot="label">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="平台支付给供应商的时间"
                    placement="right-start"
                    ><i class="el-icon-question"></i></el-tooltip
                  >
                  <span style="color: red">*</span>申请付款日期：
                </span>
                <el-date-picker
                  :picker-options="pickerOptions"
                  v-model="formData.payTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择付款日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="isRepay" label-width="140px">
                <span slot="label"> <span style="color: red">*</span>是否回款： </span>
                <el-select
                  @change="onChangeIsRepay"
                  v-model="formData.isRepay"
                  placeholder="是否回款"
                  filterable
                >
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- //!应付金额的取数逻辑之前来自结算单的费用总额字段，现在要换成结算单的应付金额 -->
            <el-col :span="8">
              <el-form-item label="" label-width="140px">
                <span slot="label"> <span style="color: red">*</span>应付金额(元)： </span>
                <el-input
                  :disabled="disabledPayAmount"
                  type="text"
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1') "
                  maxlength="12"
                  v-model="formData.payAmount"
                  placeholder="请填写付款金额"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8" v-if="formData.isRepay == 'Y'">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>关联上游收款： </span>

                <el-select
                  multiple
                  collapse-tags
                  filterable
                  style="width: 380px"
                  v-model="formData.upstreamInvoiceItem"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in reciveList"
                    :key="item.guid"
                    :label="item.receiveDate + '收款' + formatMoney(item.receiveAmount) + '元'"
                    :value="item.guid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8" v-if="formData.isRepay == 'Y'">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> 关联下游退款： </span>

                <el-select
                  multiple
                  collapse-tags
                  filterable
                  style="width: 380px"
                  v-model="formData.downstreamBackInvoiceItem"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in downstreamRefundList"
                    :key="item.guid"
                    :label="item.receiveDate + '退款' + formatMoney(item.receiveAmount) + '元'"
                    :value="item.guid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="134px">
                <span slot="label"> <span style="color: red">*</span>附件上传： </span>
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  ref="createProject"
                  :on-preview="onPreview"
                  :file-list="formData.paymentAttaches"
                  accept=".jpg,.jpeg,.png,.xlsx,.docx,.doc,.pdf"
                  :auto-upload="true"
                  :http-request="changeMainFile"
                  :limit="5"
                  :on-exceed="handleExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name || file.fileName }}</div>
                    <div class="file-preview" @click="handleMainRemove(file)">删除</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <div class="import-btn-tips">
                    <el-button size="mini" icon="el-icon-my-import" type="importNew">导入文件</el-button>
                    <div class="import-step-tip">
                      当前支持上传jpg、jpeg、png、word、excel、pdf文件，单个文件大小≤{{ fileSize }}M
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> 备注说明： </span>
                <el-input
                  style="width: 380px"
                  v-model.trim="formData.memo"
                  placeholder="请输入"
                  clearable
                  maxlength="200"
                  :rows="3"
                  resize="none"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
        <el-button type="defalut" v-if="this.$route.query.type != 2" size="mini" @click="saveForm()">保存</el-button>
        <el-button type="primary" size="mini" @click="submitForm()">{{
          this.$route.query.type == 2 ? '重新提交' : '提交申请'
        }}</el-button>
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->

    <!-- start of dialog-关联流程 -->
    <el-dialog :title="'关联流程'" class="flow-dialog" :modal="false" :visible.sync="dialogFormVisible" width="80%">
      <div class="content-main-box content-main-box2">
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div w80">关键字搜索</div>
              <el-input
                v-model="page.searchKey"
                placeholder="请输入企业、组织、应付金额搜索"
                size="mini"
                class="ipt-sty"
              >
              </el-input>
            </el-col>
            <!-- <el-col :span="8">
                            <div class="search-area-div w60">关联状态</div>
                            <el-select v-model="page.isDownStreamUsed" placeholder="请选择关联状态" size="mini" class="ipt-sty">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已关联" value="Y"></el-option>
                                <el-option label="未关联" value="N"></el-option>
                            </el-select>
                        </el-col> -->
            <el-col :span="8" class="search-btn-box">
              <el-button size="mini" type="info" @click="searchFlowList">搜索</el-button>
              <el-button size="mini" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>

        <el-table
          :header-cell-class-name="cellClass"
          stripe
          border
          ref="multipleTable1"
          highlight-current-row
          :height="tableHeight"
          :data="flowLists"
          :row-key="(row) => row.guid"
          :current-row-key="currentRowKey"
          @select="handleSelectFlow"
        >
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <!-- selection -->
          <!-- <el-table-column  :reserve-selection="true" type="selection" width="60" header-align="center" align="center"
                        fixed="left"></el-table-column> -->
          <!-- 流程名称 -->
          <el-table-column prop="flowName" label="流程名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{
              scope.row.approveVO && scope.row.approveVO.flowName ? scope.row.approveVO.flowName : '-'
            }}</template>
          </el-table-column>
          <!-- 发起人 -->
          <el-table-column
            prop="applyStaffName"
            width="96"
            label="发起人"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.applyStaffName || '-' }}
            </template>
          </el-table-column>
          <!-- 总服务商 -->
          <el-table-column prop="operationReportTenantName" :label="formData.isChangeService == 'Y' ? '总服务商' : '企业名称'" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.operationReportTenantName || '-' }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="formData.isChangeService == 'Y'"
            prop="tenantName" 
            label="接包服务商" 
            header-align="center" 
            align="left" 
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.tenantName || '-' }}
            </template>
          </el-table-column>
          <!-- 组织名称 -->
          <el-table-column
            prop="organisationName"
            label="组织名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.organisationName || '-' }}
            </template>
          </el-table-column>
          <!-- 核算月 -->
          <el-table-column prop="accountMonth" label="核算月" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.newAccountMonth || '-' }}
            </template>
          </el-table-column>
          <!-- 任务包名称 -->
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.operationReportTaskTitle ? JSON.parse(scope.row.operationReportTaskTitle).join('、') : '-'
            }}</template>
          </el-table-column>
          <!-- 应付金额 -->
          <el-table-column
            prop="payable"
            label="应付金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ (scope.row.payable || '-') | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="billCycleList"
            label="期数"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.billCycleList ? scope.row.billCycleList.join('、') : '-' }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="txt-color" @click="seeDetail(scope.row)">查看详情</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- start of pagination -->
        <!-- <el-pagination
                    class="pt pb back-color-fff"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="page.pageIndex"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.totalRows"
                >
                </el-pagination> -->
        <!-- end of pagination -->
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="selectProcess()">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of dialog-关联流程 -->
    <ChoosePerson ref="choosePerson" staffType="1" @onSelect="onPersonSelect"></ChoosePerson>
    <OperationReportDialog 
      ref="operationReportDialogRef" 
      @submit="handleOperationReportSubmit" 
      @close="handleOperationReportClose"
    ></OperationReportDialog>
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import Decimal from 'decimal.js';

import store from '@/store';
import ChoosePerson from './components/choosePersonOne';
import OperationReportDialog from './components/OperationReportDialog.vue';
import getTenantDetail from '../../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../../mixins/getTenantDetail'
export default {
  components: {
    ChoosePerson,
    OperationReportDialog,
  },
  mixins: [getTenantDetail],
  data() {
    let userInfo = JSON.parse(localStorage.userInfo);
    return {
      ServiceProviderTypeEnum,
      fullscreenLoading: false,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      guid: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      serviceTenantList: [],
      operationReportList: [], // 关联运营报告列表
      formData: {
        operationReportTenantGuid: '', // 药企名称
        isChangeService: 'N', // 是否转包任务
        operationReportGuid: '', // 关联运营报告
        memo: '',
        relevance: '', // 关联流程
        accountMonth: '', // 核算月统一为 JSON 数组字符串，完整保留多月
        payTime: '', // 结算时间
        isInvoiced: '', // 是否已开票
        payBankAccount: '',
        payBankName: '',
        receiveBankAccount: '',
        receiveBankName: '',
        receiveTenantGuid: '', // 收款方公司GUID
        upstreamInvoiceItem: [],
        isRepay: '',
        paymentAttaches: [],
        payAmount: null,
        payBankInfoList: [], // 多个银行付款信息
      },

      formRules: {},
      detailData: {},
      tableData: [
        {
          key: 1,
          taskContent: '结算金额(元)',
          settleAmount: 'settleAmount',
          memo: '个人结算明细表',
        },
        {
          key: 2,
          taskContent: '结算人数(个)',
          settleAmount: 'personNum',
          memo: '详见结算明细表',
        },
        {
          key: 3,
          taskContent: '服务费(元)',
          settleAmount: 'serviceAmount',
          memo: '服务费费率',
        },
        {
          key: 4,
          taskContent: '结算总额(元)',
          settleAmount: 'payable',
          memo: '结算金额+服务费金额',
        },
      ],

      // 关联流程相关
      dialogFormVisible: false,
      accountMonthPick: '', // 核算月手填值（单月 yyyyMM；带出场景不使用）
      savedAccountMonth: '', // 编辑时已保存的核算月，补填中的值不提前锁定
      operationReportAccountMonth: '', // 所选运营报告的核算月，报告无月份时允许手填
      page: {
        pageIndex: 1,
        pageSize: -1,
        staffGuid: userInfo.staffGuid,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        serviceTenantGuid: localStorage.guid,
        flowTypeList: ['00021'], // 00021:结算单流程,00022:付款单流程
        isDownStreamUsed: 'N',
      },
      flowLists: [],
      tableHeight: '37.5vh',
      // 流程图相关
      iframeSh: false,
      iframeSrc: '',

      currentRow: '',
      currentRowKey: '',

      payBankList: [],
      receiveBankList: [],
      threeServiceList: [], // 三方服务公司列表
      reciveList: [],
      downstreamRefundList: [],
      fileSize: serverConfig.FILE_SIZE,
      personShow: false,
      selectSettDoc:[], // 勾选的结算单
      operationReportDialogVisible: false, // 运营报告弹窗
      operationReportName: '', // 运营报告名称显示
    };
  },
  created() {
    // 获取流程数据
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetail();
    } else {
      this.getApprovalList();
    }
    this.Mixins_getServiceProviderType();
  },
  watch: {
    // "formData.isRepay"(){
    //     this.formData.upstreamInvoiceItem = [];
    // }
  },
  computed: {
    operationReportTenantName() {
      return (
        this.serviceTenantList.find(
          (item) => item.sendTenantGuid == this.formData.operationReportTenantGuid
        )?.sendTenantName || ""
      );
    },
    disabledPayAmount() {
      if (this.formData.isChangeService == 'N') {
        return true;
      }
      return Boolean(this.formData.relevance);
    },
    // 无月份来源的草稿可修改手填月份，其他已保存月份保持只读
    accountMonthDisabled() {
      const editableDraft = this.$route.query.type == 1 && this.formData.approveState === 'N'
        && !this.formData.relevance && !this.operationReportAccountMonth;
      if (this.$route.query.guid && this.savedAccountMonth && !editableDraft) {
        return true;
      }
      if (this.formData.relevance) {
        return true;
      }
      if (this.formData.isChangeService == 'Y' && this.formData.operationReportGuid && this.operationReportAccountMonth) {
        return true;
      }
      return false;
    },
    // 带出/历史值展示：JSON数组转逗号文本（多月如实显示，不截断）
    accountMonthText() {
      try {
        const arr = JSON.parse(this.formData.accountMonth || '[]');
        return Array.isArray(arr) ? arr.join(',') : this.formData.accountMonth;
      } catch (e) {
        return this.formData.accountMonth;
      }
    },
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    settleGuids() { // 取历史记录
      const guids = Array.isArray(this.formData.paymentSettleList) ? this.formData.paymentSettleList.map(item=>item.settleGuid) : [];
      return guids.length ? guids : this.formData.parentGuid ? [this.formData.parentGuid] : [];
    }
  },
  methods: {
    //获取服务商
    async getServiceTenantList() {
      let query = {
        tenantGuid: localStorage.guid,
      };
      const { data } = await this.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenant-and-three-service`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenantList = data?.data || [];
    },
    /**
     * 搜索关联流程
     */
    searchFlowList() {
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList(true);
    },
    onChangeIsRepay(){
      this.formData.upstreamInvoiceItem = [];
      if(this.guid){
        this.getReciveList(this.formData);
        this.getDownstreamRefund(this.formData);
      }
    },
    // 清除流程时同时清空历史关系和来源金额，其他已选报告继续作为月份来源。
    clearSelectedFlow() {
      const userInfo = JSON.parse(localStorage.userInfo);
      const bank = this.formData.payBankInfoList[0] || {};
      this.formData.relevance = '';
      this.$set(this.formData, 'parentGuid', null);
      this.$set(this.formData, 'paymentSettleList', []);
      this.formData.payAmount = '';
      this.formData.upstreamInvoiceItem = [];
      this.formData.payBankInfoList = [{ payBankName: bank.payBankName, payBankAccount: bank.payBankAccount, payAmount: null }];
      this.detailData = {
        serviceTenantGuid: this.formData.serviceTenantGuid || localStorage.guid,
        serviceTenantName: this.formData.serviceTenantName || userInfo.tenantName,
      };
      this.selectSettDoc = [];
      this.currentRow = '';
      this.currentRowKey = '';
      this.$refs.multipleTable1?.clearSelection();
      this.setAccountMonth(this.savedAccountMonth || this.operationReportAccountMonth || this.formData.accountMonth);
    },
    // 清除报告保留当前付款月；无其他来源时允许用户手动修改。
    clearSelectedReport() {
      this.formData.operationReportGuid = '';
      this.formData.operationReportName = '';
      this.$set(this.formData, 'operationReport', null);
      this.operationReportAccountMonth = '';
      this.setAccountMonth(this.formData.accountMonth);
    },
    changeService() {
      const userInfo = JSON.parse(localStorage.userInfo);
      this.formData.relevance = '';
      this.formData.payAmount = '';
      this.formData.operationReportGuid = '';
      this.formData.operationReportName = '';
      this.operationReportAccountMonth = '';
      this.setAccountMonth(this.formData.accountMonth);
      this.formData.receiveTenantGuid = '';
      this.formData.operationReportTenantGuid = '';
      this.selectSettDoc = [];
      this.$refs.multipleTable1?.clearSelection();
      if(this.formData.isChangeService == 'N') {
        this.formData = {
          ...this.formData,
          payBankInfoList: [],
          receiveBankName: "",
          receiveBankAccount: ""
        }
        this.receiveBankList = [];
        return
      }
      this.detailData.serviceTenantName = userInfo.tenantName;
      this.formData = {
        ...this.formData,
        payBankInfoList: [
          {
            receiveBankName: null,
            payBankAccount: null,
          },
        ],
      }
      this.getServiceTenantList();
      this.getThreeService();
      this.getBankList(localStorage.guid,userInfo.tenantGuid,1);
    },
    // 打开运营报告弹窗
    focusOperationReport() {
      const data = {
        selectSettDoc: this.selectSettDoc,
        detailData: this.formData,
        operationReportGuid: this.formData?.operationReportGuid || '',
      }
      this.$refs.operationReportDialogRef.open(data);
    },
    // 处理运营报告选择
    handleOperationReportSubmit(row) {
      let userInfo = JSON.parse(localStorage.userInfo);
      const currentPayAmount = new Decimal(row.currentPayAmount || 0)?.toFixed(2);
      const tenantName = row.taskTitleName?.split("-")?.[1];
      const operationReportName = `${userInfo.staffName}_${tenantName}_${row.accountMonthName}_${currentPayAmount}(元)`
      this.formData = {
        ...this.formData,
        operationReportGuid: row.guid,
        operationReportName: operationReportName,
      }
      this.operationReportAccountMonth = this.normalizeAccountMonth(row.accountMonthName || row.accountMonth);
      // 无关联流程时随报告切换月份；报告无月份则保留当前值供用户确认、修改
      const editableDraft = this.$route.query.type == 1 && this.formData.approveState === 'N';
      if ((!this.savedAccountMonth || editableDraft) && !this.formData.relevance) {
        this.setAccountMonth(this.operationReportAccountMonth || this.formData.accountMonth);
      }
    },
    // 运营报告弹窗关闭
    handleOperationReportClose() {
      // 弹窗关闭时的处理
    },
    addPayBank() {
      if (!this.formData.relevance) {
        this.$message.error('请选择关联流程');
        return;
      }
      // 切换时 清空已选
      if (this.formData.payBankInfoList.length > 1) {
        this.formData.payBankInfoList = [
          {
            ...this.detailData.settleDetail[0],
            // payAmount: this.detailData.settleDetail[0].totalAmount, // 付款金额 默认当前 开票金额
            // 重复展开关闭时, 已填内容置空
            receiveBankName: null,
            payBankAccount: null,
          }
        ];
      } else {
        this.formData.payBankInfoList = this.detailData.settleDetail?.map(item => {
          return {
            ...item,
            payAmount: item.totalAmount, // 付款金额 默认当前 开票金额
            // 重复展开关闭时, 已填内容置空
            receiveBankName: null,
            payBankAccount: null,
          };
        });
      }
      
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disabledCheck';
      }
    },

    focusRelevance() {
      this.dialogFormVisible = true;
      this.searchFlowList();
    },
    /**
     * 保存
     */
    saveForm() {
      if (!this.checkForm()) return;
      return this.postFormData(false);
    },
    /**
     * 提交
     */
    submitForm() {
      if (!this.checkForm(true)) return;
      if (this.personShow && !this.formData.startAssigner) {
        this.$refs.choosePerson.visible = true;
        return;
      }
      return this.postFormData(true);
    },
    checkForm(submitting = false) {
      if(!this.formData.isChangeService){
        this.$message.error('请选择是否转包任务');
        return false;
      }
      if (!this.formData.relevance && this.formData.isChangeService == 'N') {
        this.$message.error('关联流程不能为空');
        return false;
      }
      // 核算月动态必填：仅在可填场景（未带出来源）校验——即转包未关联流程且未选报告的垫资路径，及历史NULL单补填
      if (!this.accountMonthDisabled && !this.accountMonthPick) {
        this.$message.error('请选择核算月');
        return false;
      }
      if(this.formData.isChangeService == 'Y' && !this.formData.operationReportTenantGuid){
        this.$message.error('请选择药企名称');
        return false;
      }
      const payBankInfoList = this.formData.payBankInfoList;
      if (payBankInfoList.length == 1 && !payBankInfoList[0].payBankName) {
        this.$message.error('付款开户银行不能为空');
        return false;
      }
      if (payBankInfoList.length > 1) {
        const f = payBankInfoList.every(item => {
          return item.payBankName && item.payAmount >= 0;
        })
        if (!f) {
          this.$message.error('付款开户银行不能为空');
          return false;
        }
      }
      if (!this.formData.receiveBankName) {
        this.$message.error('收款开户银行不能为空');
        return false;
      }
      if (!this.formData.receiveBankAccount) {
        this.$message.error('收款开户银行账号不能为空');
        return false;
      }
      if (!this.formData.payTime) {
        this.$message.error('付款时间不能为空');
        return false;
      }
      if (!this.formData.isRepay) {
        this.$message.error('是否回款不能为空');
        return false;
      }
      if (
        (!this.formData.upstreamInvoiceItem || !this.formData.upstreamInvoiceItem.length) &&
        this.formData.isRepay == 'Y'
      ) {
        this.$message.error('关联上游收款不能为空');
        return false;
      }
      if (!this.formData.paymentAttaches.length) {
        this.$message.error('请上传附件');
        return false;
      }
      return !submitting || this.checkAccountMonthSources();
    },
    postFormData(flag, accountMonthConfirmation = '') {
      if (flag && !this.checkAccountMonthSources()) return;
      if (flag) {
        const context = this.accountMonthSubmissionContext();
        if (accountMonthConfirmation && accountMonthConfirmation !== context.snapshot) {
          this.$message.error('关联单据或核算月已变更，请重新确认后提交');
          return;
        }
        if (context.crossMonth && !accountMonthConfirmation) {
          const h = this.$createElement;
          const message = h('div', [
            h('p', `关联流程核算月：${context.sourceMonth ? this.formatAccountMonth(context.sourceMonth) : '未关联流程'}`),
            h('p', `运营报告核算月：${this.formatAccountMonth(context.reportMonth)}`),
            h('p', `本付款单最终核算月：${this.formatAccountMonth(context.month)}`),
            h('p', { style: { marginTop: '12px' } }, '请核对是否选错单据。如确认需要跨核算月关联，可继续提交。'),
          ]);
          return this.$confirm(message, '关联单据的核算月不一致', {
            type: 'warning',
            confirmButtonText: '确认跨核算月提交',
            cancelButtonText: '返回修改',
            closeOnClickModal: false,
          }).then(() => this.postFormData(true, context.snapshot), () => false);
        }
      }
      let self = this;
      let postData = JSON.parse(JSON.stringify(this.formData));
      // 确认只属于本次提交，草稿及后续重新点击提交均不复用。
      postData.accountMonthConfirmation = flag ? accountMonthConfirmation || null : null;
      let userInfo = JSON.parse(localStorage.userInfo);
      // postData['settleGuid'] = this.detailData.guid; // !结算单单选模式
      postData['applyStaffGuid'] = userInfo['staffGuid'];
      postData['applyStaffName'] = userInfo['staffName'];
      postData['settleGuids'] = this.selectSettDoc.map(item=>item.guid)
      postData['serviceTenantGuid'] = this.detailData.serviceTenantGuid || localStorage.guid;
      postData['serviceTenantName'] = this.detailData.serviceTenantName || JSON.parse(localStorage.userInfo).tenantName;
      postData["tenantGuid"] =
        this.formData.receiveTenantGuid || this.detailData.tenantGuid || null;
      postData["tenantName"] =
        this.threeServiceList.find(
          (item) => item.sendTenantGuid === this.formData.receiveTenantGuid
        )?.sendTenantName ||
        this.detailData.tenantName ||
        null;
      // postData['payAmount'] = this.detailData.payable || null;
      postData['immediateSubmit'] = flag; // false是保存 true是保存
      postData.paymentAttaches.forEach((item) => {
        item.fileName = item.name;
      });

      let payBankGuid = postData.payBankName;
      let receiveBankGuid = postData.receiveBankName;
      this.payBankList.forEach((item) => {
        if (item.guid == payBankGuid) {
          postData.payBankName = item.bankName;
        }
      });
      this.receiveBankList.forEach((item) => {
        if (item.guid == receiveBankGuid) {
          postData.receiveBankName = item.bankName;
        }
      });
      postData['operationReportTenantName'] = this.operationReportTenantName || null;
      // 没有选择多个银行付款信息时 赋予默认值
      if (postData.payBankInfoList.length == 1) {
        postData.payBankInfoList[0].payAmount = postData.payAmount;
        postData.payBankInfoList[0].settleDate = postData.payTime;
        // 单个银行付款 不要任务大类
        postData.payBankInfoList[0].taskType = null;
      }
      if (this.$route.query.guid) { // #重新提交
        postData['settleGuids'] = this.selectSettDoc.length ? this.selectSettDoc.map(item => item.guid) : this.settleGuids
        postData['serviceTenantGuid'] = this.formData.serviceTenantGuid || this.detailData.serviceTenantGuid || localStorage.guid;
        postData['serviceTenantName'] = this.formData.serviceTenantName || this.detailData.serviceTenantName || JSON.parse(localStorage.userInfo).tenantName;
        postData['tenantGuid'] = postData.tenantGuid || null;
        postData['tenantName'] = postData.tenantName || null;
        // postData['payAmount'] = postData.payAmount || null;
        postData['guid'] = this.$route.query.guid;
        postData['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;// 重新提交
        this.fullscreenLoading = true;
        return self.api.put(`/${serverConfig.msSalesPerformService}/downstream/payment/update`, postData).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (flag) {
              self.$message.success('提交成功！');
            } else {
              self.$message.success('保存成功！');
            }
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        }).finally(() => { this.fullscreenLoading = false; });
      } else {
        this.fullscreenLoading = true;
        return self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/payment/add`, postData).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (flag) {
              self.$message.success('提交成功！');
            } else {
              self.$message.success('保存成功！');
            }
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        }).finally(() => { this.fullscreenLoading = false; });
      }
    },
    // 获取付款总金额(展示用)
    getTotalPayable() {
      let payable = this.selectSettDoc.map(item=>item.payable ? item.payable : 0)
      return payable.reduce((prev, cur) => prev + Number(cur?.toFixed(2) || 0), 0);
    },
    async getThreeService() {
      const { data } = await this.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-three-service`
      );
      if(data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.threeServiceList = data.data || [];
    },
    /**
     * 选择流程
     */
    async selectProcess() {
      let { currentRow } = this;
      if (!currentRow['guid']) return this.$message.error('请关联流程');
      // 关联流程后显示发起人 + 代征公司简称 + 月份 + 费用总金额
      this.formData.relevance = `${currentRow['applyStaffName']} _ ${currentRow['tenantName']} _ ${currentRow['newAccountMonth']}${(this.selectSettDoc.some(item=>item.payable) ? ' _ ' + this.formatMoney(this.getTotalPayable()) + '(元)' : '')}`
      // 核算月随关联流程带出（结算单/对账单行原样JSON数组，多月不拆）
      this.setAccountMonth(this.savedAccountMonth || currentRow['accountMonth'] || '');
      this.formData.payAmount = this.getTotalPayable().toFixed(2) // #结算单应付金额相加
      // this.formData.payAmount = currentRow['payable']; // #应付金额的取数逻辑之前来自结算单的费用总额字段，现在要换成结算单的应付金额
      this.formData.upstreamInvoiceItem = [];
      this.formData = {
        ...this.formData,
        receiveBankName: '',
        receiveBankAccount: '',
      }
      await this.getDetailData(this.selectSettDoc,'isSelectProcess');
      // this.getReciveList(currentRow.operationReportTenantGuid);
      this.getReciveList(currentRow);
      this.getDownstreamRefund(currentRow);
      this.dialogFormVisible = false;
    },
    /**
     * 获取详情
     */
    async getDetailData(data,type) {
      let guids = []
      if (data.parentGuid) {
        guids = [data.parentGuid]
      }
      if (type == "isSelectProcess") { 
        guids = this.selectSettDoc.map(item=>item.guid)
      }
      if(!guids?.length) {
        return;
      }
      let url = `/downstream/settle/detail-list`
      if(this.formData.isChangeService == 'Y') {
        url = `/downstream/statement/detail-list`
      }
      await this.api.postJson(`/${serverConfig.msSalesPerformService}${url}`,guids).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          data.serviceTenantName = data.servicerName || data.serviceTenantName;
          data.serviceTenantGuid = data.servicerGuid || data.serviceTenantGuid;
          this.detailData = data;
          // 选择关联流程 后赋值
          if (type == "isSelectProcess") {
            this.formData.payBankInfoList = [
              {
                ...data.settleDetail[0],
                receiveBankName: null,
                payBankAccount: null,
              },
            ];
            if(this.formData.isChangeService == 'Y') {
              this.formData.operationReportTenantGuid = data.operationReportTenantGuid;
            }
            this.formData = {
              ...this.formData,
            }
          }
        
          this.getBankList(data.serviceTenantGuid,'',1);
          this.getBankList(data.serviceTenantGuid,data.tenantGuid, 2);
          // this.getApprovalList();
        } else {
          this.$message.error(msg);
        }
      });
    },
    //获取详情
    getDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/downstream/payment/detail/${self.$route.query.guid}`)
        .then(async (res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.formData = data;
            this.formData.payBankInfoList = data.payBankInfoList;
            this.savedAccountMonth = this.normalizeAccountMonth(data.accountMonth);
            this.operationReportAccountMonth = this.normalizeAccountMonth(data.operationReport?.accountMonth);
            const sourceAccountMonth = this.normalizeAccountMonth(data.paymentSettleList?.[0]?.accountMonth);
            const reportAccountMonth = data.isChangeService == 'Y' && !data.parentGuid
              ? this.operationReportAccountMonth : '';
            this.setAccountMonth(this.savedAccountMonth || sourceAccountMonth || reportAccountMonth);

            // console.log(data)
            let accountMonth = this.formData.accountMonth ? JSON.parse(this.formData.accountMonth) : [];
            // 显示发起人 + 药企简称 + 月份 + 应付金额
            if (data.parentGuid) {
              this.formData['relevance'] = `${data['applyStaffName']} _ ${data['tenantName']} _ ${accountMonth.join(' , ')}${(data['payable'] ? ' + ' + this.formatMoney(data['payable']) + '(元)' : '')}`
              if (this.formData['paymentAttaches'] && this.formData['paymentAttaches'].length) {
                this.formData['paymentAttaches'].forEach((item) => {
                  item.name = item.fileName;
                });
              }
            }
            if (!data.parentGuid) {
              this.detailData.serviceTenantName = data.serviceTenantName;
              this.formData.receiveTenantGuid = data.tenantGuid;
              this.getThreeService();
              this.getBanks(data.tenantGuid);
              this.getBankList(data.serviceTenantGuid,'',1);
            }
            if (data.isChangeService == 'Y') {
              this.formData.operationReportGuid = data.operationReportGuid;
              this.getServiceTenantList();
            }
            const operationReportTenantName =
              data.operationReport?.taskTitleName?.split("-")?.[1];
            const operationReportAccountMonth =
              data.operationReport?.accountMonth || "";
            const operationReportCurrentPayAmount =
              data.operationReport?.currentPayAmount || "";
            let operationReportName = '';
            if (data.operationReportGuid) {
              operationReportName = `${data.applyStaffName}_${operationReportTenantName}_${operationReportAccountMonth}_${operationReportCurrentPayAmount}(元)`;
            }
            this.formData.operationReportName = operationReportName;
            await this.getDetailData(data);
            if(data.isRepay == 'Y') {
              this.getReciveList(data);
              this.getDownstreamRefund(data);
            } 
            this.getApprovalList();
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取付/收款银行
     */
    async getBankList(serviceTenantGuid,tenantGuid,type) {
      let self = this;
      if (type == 1) {
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${serviceTenantGuid}`)
          .then((res) => {
            let { code, data, msg } = res.data;
            if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.payBankList = data.bankList;
              if (this.$route.query.guid) {
                self.payBankList.forEach((item) => {
                  if (item.bankName == this.formData.payBankName && item.bankAccount == this.formData.payBankAccount) {
                    this.formData.payBankName = item.guid;
                  }
                });
              }
            } else {
              self.$message.error(msg);
            }
          });
      }
      if (type == 2) {
        let receiveBankRes;
        if (this.formData.isChangeService == 'N') {
          const req = {
            serviceTenantGuid: serviceTenantGuid,
            tenantGuid: tenantGuid,
          };
          receiveBankRes = await this.api.postJson(
            `/${serverConfig.msCustomerService}/tenant/data/get-banks-by-rel`,
            req
          );
        } else {
          const req = {
            tenantGuids: [this.detailData.tenantGuid],
          };
          receiveBankRes = await this.api.postJson(
            `/${serverConfig.msCustomerService}/tenant/data/get-banks`,
            req
          );
        }
        let { code, data, msg } = receiveBankRes.data;
        if(code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(msg);
          return;
        }
        if (!data?.length) {
          return
        }
        self.receiveBankList = data[0]?.bankList || [];
        if (this.$route.query.guid) {
          self.receiveBankList.forEach((item) => {
            if (
              item.bankName == this.formData.receiveBankName &&
              item.bankAccount == this.formData.receiveBankAccount
            ) {
              this.formData.receiveBankName = item.guid;
            }
          });
        }
      }
    },
    changeOperationReportTenant() {
      this.getReciveList(this.currentRow);
    },
    onChangePayAmountItem(value, item, index) {
      let newValue = value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      this.formData.payBankInfoList[index].payAmount = newValue;
      const maxValue = item.totalAmount;
      if (newValue > maxValue) {
        newValue = maxValue;
        this.$message.error('付款金额不能大于开票金额');
      }
      this.$set(this.formData.payBankInfoList, index, { ...item, payAmount: newValue });
      return newValue;
    },
    payBankNameChange(value, index) {
      const payBank = this.payBankList.find((item) => item.bankName === value);
      console.log(payBank,this.formData.payBankInfoList);
      if (index > 0) {
        this.formData.payBankInfoList[index].payBankAccount = payBank.bankAccount;
        this.formData.payBankInfoList[index].payBankName = value;
      } else {
        this.formData.payBankInfoList[0].payBankAccount = payBank.bankAccount;
        this.formData.payBankInfoList[0].payBankName = value;
      }
      this.formData.payBankInfoList = [...this.formData.payBankInfoList];
    },
    reciveBankNameChange(val) {
      this.receiveBankList.forEach((item) => {
        if (val == item.guid) {
          this.formData.receiveBankAccount = item.bankAccount;
        }
      });
      console.log(val);
    },
    // 获取收款方银行
    async getBanks(tenantGuid) {
      let res;
      if (this.formData.isChangeService == 'N') {
        const serviceTenantGuid = this.detailData.serviceTenantGuid || localStorage.guid;
        const req = {
          serviceTenantGuid: serviceTenantGuid,
          tenantGuid: tenantGuid,
        };
        res = await this.api.postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-banks-by-rel`,
          req
        );
      } else {
        const req = {
          tenantGuids: [tenantGuid],
        };
        res = await this.api.postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-banks`,
          req
        );
      }
      if(res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(res.data.msg);
        return;
      }
      if (!res.data.data?.length) {
        return;
      }
      this.receiveBankList = res.data.data[0]?.bankList || [];
    },
    // 收款方公司选择变化
    async onReceiveTenantChange(tenantGuid) {
      if (!tenantGuid) {
        this.receiveBankList = [];
        this.formData.receiveBankName = '';
        this.formData.receiveBankAccount = '';
        return;
      }
      await this.getBanks(tenantGuid);
      this.formData.receiveBankName = '';
      this.formData.receiveBankAccount = '';
    },
    /**
     * 关联上游收款
     */
    getReciveList(data) {
      let self = this;
      let settleGuid = data.guid;
      if(this.guid) {
        settleGuid = data.paymentSettleList?.[0]?.settleGuid;
      }
      let payTenantGuid = this.formData.isChangeService == 'Y' ? this.formData.operationReportTenantGuid : data.qualityAssessmentTenantGuid;
      let receiveTenantGuid = localStorage.guid;
      if(this.formData.isChangeService == 'Y') {
        receiveTenantGuid = null;
      } 
      let req = {
        streamType: 1,
        payTenantGuid: payTenantGuid,
        pageIndex: 1,
        pageSize: -1,
        receiveTenantGuid,
        isQueryChild: 'Y',
        settleGuid: settleGuid,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/get-select-list`, req).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reciveList = data;
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 关联下游退款
     */
    getDownstreamRefund(data) {
      let self = this;
      let settleGuid = data.guid;
      if(this.guid) {
        settleGuid = data.paymentSettleList?.[0]?.settleGuid;
      }
      let receiveTenantGuid = data.receiveTenantGuid || localStorage.guid;
      if(this.formData.isChangeService == 'Y') {
        receiveTenantGuid = null;
      } 
      let req = {
        streamType: 3,
        isDownstreamUsed: 'N',
        receiveTenantGuid,
        pageIndex: 1,
        pageSize: -1,
        isQueryChild: 'Y',
        // operationReportTenantGuid: data.operationReportTenantGuid,
        settleGuid: settleGuid,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/get-select-list`, req).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.downstreamRefundList = data || [];
        } else {
          self.$message.error(msg);
        }
      });
    },
    // 关联流程-对账单
    async getStatementList() {
      const params = {
        serviceTenantGuid: localStorage.guid,
        accountMonth: this.page.accountMonth,
        searchKey: this.page.searchKey,
        billTypeList: [3], // [3]查对账单
        approveStateList: ['Y'],
      }
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/list`,
        params
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let list = data.data || [];
      this.flowLists = list.map(item => {
        let newAccountMonth = JSON.parse(item.accountMonth) || [];
        newAccountMonth = newAccountMonth?.join(',') || '';
        return {
          ...item,
          newAccountMonth: newAccountMonth || '',
        }
      });
    },
    /**
     * 获取关联流程列表数据
     */
    getFlowList(flag = false) {
      if (flag) {
        this.page.pageIndex = 1;
        this.flowLists = [];
      }
      let self = this;
      let postData = {
        ...this.page,
        approveState: 'Y',
        isSettleHedgeUsed:'N', // !过滤已经对冲的结算单
        listType: 1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/page-list`, postData).then((res) => {
        let { code, msg, data } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = data.records || [];
          list.forEach((item) => {
            let accountMonth = JSON.parse(item.accountMonth) || [];
            item.newAccountMonth = accountMonth.join(',');
          });
          self.flowLists = list;
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 修改当前页的数量
     * @param {*} val
     */
    handleSizeChange(val) {
      this.page.pageSize = val;
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 修改分页
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page.pageIndex = val || 1;
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 关联流程，查看详情
     */
    see() {},
    /**
     * 勾选关联流程数据
     */
    flowListsChange(selection, row) {
      this.$refs.multipleTable1.clearSelection();
      row.flag = !row.flag;
      this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
      this.currentRowKey = row.guid;
      this.currentRow = row;
    },
    handleSelectFlow(selection, row) {
      let fristServicerGuid = selection[0] && selection[0].servicerGuid ? selection[0].servicerGuid : ''
      let fristTenantGuid = selection[0] && selection[0].tenantGuid ? selection[0].tenantGuid : ''
      let qualityAssessmentTenantGuid = selection[0] && selection[0].qualityAssessmentTenantGuid ? selection[0].qualityAssessmentTenantGuid : ''
      let accountMonth = this.normalizeAccountMonth(selection[0]?.accountMonth)
      if (this.formData.isChangeService == 'N') {
        if (!selection.every(item=> qualityAssessmentTenantGuid === item.qualityAssessmentTenantGuid && accountMonth === this.normalizeAccountMonth(item.accountMonth))) {
            this.$message.error('请选择相同公司的相同核算月');
            this.$refs.multipleTable1.toggleRowSelection(row, false);
            return
        }
        if (!selection.every(item => fristServicerGuid === item.servicerGuid && fristTenantGuid === item.tenantGuid)) {
          this.$message.error('请选择服务商、代征公司一致的结算单');
          this.$refs.multipleTable1.toggleRowSelection(row, false);
          return
        }
      }
      if (this.formData.isChangeService == 'Y') {
        // 同一个提交人、同一个核算月、同一个部门允许选择多个对账单生成付款单
        // 否则拦截提示：请选择同一个核算月、同一个部门，同一个提交人员的对账单
        let firstServiceTenantGuid = selection[0]?.serviceTenantGuid || '';
        let firstApplyStaffGuid = selection[0]?.applyStaffGuid || '';
        console.log(firstServiceTenantGuid,firstApplyStaffGuid,accountMonth,selection)
        const f = selection.every(
          (item) =>
            firstServiceTenantGuid === item.serviceTenantGuid &&
            firstApplyStaffGuid === item.applyStaffGuid &&
            accountMonth === this.normalizeAccountMonth(item.accountMonth)
        );
        if (!f) {
          this.$message.error(
            "请选择同一个核算月、同一个部门，同一个提交人员的对账单"
          );
          this.$refs.multipleTable1.toggleRowSelection(row, false);
          return;
        }
      }
      this.currentRow = row;
      this.currentRowKey = row.guid;
      this.selectSettDoc = selection
    },
    /**
     * 清空条件搜索,重新获取流程列表数据
     */
    empty() {
      const userInfo = JSON.parse(localStorage.userInfo);
      this.page = {
        pageIndex: 1,
        pageSize: -1,
        staffGuid: userInfo.staffGuid,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        serviceTenantGuid: localStorage.guid,
        flowTypeList: ['00021'], // 00021:结算单流程,00022:付款单流程
        isDownStreamUsed: 'N',
      };
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 获取流程列表
     */
    async getApprovalList() {
      const userInfo = JSON.parse(localStorage.userInfo);
      const { approveVO } = this.formData;
      if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {

        this.iframeSrc = `${bpmnroute}/iframeBpmn?processInstanceId=${approveVO.camundaInstanceId}&camundaDeploymentId=${approveVO.camundaDeploymentId}&token=${localStorage.token}`;
        this.isLastPerson(approveVO.camundaDeploymentId);
        this.iframeSh = true;
        this.$forceUpdate()
      } else {
        try {
          const req = {
            tenantGuid: localStorage.guid,
            flowType: '00022',
            staffGuid: userInfo.staffGuid,
          };
          const res = await this.api.postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
            req,
          );
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.isLastPerson(res.data.data);
              this.iframeSrc = `${bpmnroute}/iframeBpmn?camundaDeploymentId=${res.data.data}&token=${localStorage.token}`;
              this.iframeSh = true;
              this.$forceUpdate()
            } else {
              this.$message.error('未获取到流程信息');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        } catch (error) {
          this.$message.error('请求出错');
        }
      }
    },

    /**
     * 数字金额转大写
     * @param {*} num
     */
    convertToChinese(num) {
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    /** 导入**************************************** */
    onPreview(file) {
      var fileSuffix;
      if (file.name) {
        fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      }
      if (file.fileName) {
        fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      }

      if (
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf' ||
        fileSuffix === 'zip' ||
        fileSuffix === 'rar'
      ) {
        return window.open(file.path);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
        this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.formData.paymentAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            console.log(this.paymentAttaches);
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleMainRemove(file) {
      this.formData.paymentAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.formData.paymentAttaches.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件`);
    },
    // 报告详情返回逗号串，选择列表/付款单返回 JSON 数组；统一比较和提交格式。
    normalizeAccountMonth(value) {
      const text = value == null ? '' : String(value).trim();
      if (!text || text === 'null') return '';
      const values = Array.isArray(value) ? value : text.startsWith('[') ? JSON.parse(text) : text.split(',');
      const months = [...new Set(values.map((month) => String(month).trim()))].sort();
      if (months.some((month) => !/^\d{4}(0[1-9]|1[0-2])$/.test(month))) {
        throw new Error('核算月格式错误');
      }
      return months.length ? JSON.stringify(months) : '';
    },
    // 流程内部同月及付款单月份完整性仍为硬约束，报告跨月改为提交时明确确认。
    checkAccountMonthSources() {
      try {
        const month = this.normalizeAccountMonth(this.formData.accountMonth);
        if (!month) {
          this.$message.error('请选择核算月');
          return false;
        }
        this.normalizeAccountMonth(this.operationReportAccountMonth);
        const sources = this.selectSettDoc.length ? this.selectSettDoc : this.formData.paymentSettleList || [];
        const sourceMonths = sources.map((item) => [item.accountMonth, '关联流程']);
        for (const [value, sourceName] of sourceMonths) {
          const sourceMonth = this.normalizeAccountMonth(value);
          if (sourceMonth && month !== sourceMonth) {
            this.$message.error(`付款单核算月为${this.formatAccountMonth(month)}，${sourceName}核算月为${this.formatAccountMonth(sourceMonth)}，请重新选择同月单据`);
            return false;
          }
        }
        return true;
      } catch (e) {
        this.$message.error('核算月格式错误，请重新选择月份或关联单据');
        return false;
      }
    },
    formatAccountMonth(value) {
      return JSON.parse(this.normalizeAccountMonth(value) || '[]')
        .map((month) => `${month.slice(0, 4)} 年 ${Number(month.slice(4))} 月`).join('、');
    },
    // 与后端按相同顺序构造确认快照，绑定目标付款单、来源标识及当前规范化月份。
    accountMonthSubmissionContext() {
      const month = this.normalizeAccountMonth(this.formData.accountMonth);
      const reportMonth = this.normalizeAccountMonth(this.operationReportAccountMonth);
      const sources = this.selectSettDoc.length ? this.selectSettDoc : this.formData.paymentSettleList || [];
      const sourceGuids = [...new Set(sources.map((item) => item.guid || item.settleGuid).filter(Boolean))].sort();
      if (!sourceGuids.length && this.formData.parentGuid) sourceGuids.push(this.formData.parentGuid);
      const sourceMonth = sourceGuids.length ? this.normalizeAccountMonth(sources[0]?.accountMonth || month) : '';
      const paymentGuid = this.$route.query.type == 2 ? '' : this.$route.query.guid || '';
      const reportGuid = this.formData.operationReportGuid || '';
      return {
        month, reportMonth, sourceMonth,
        crossMonth: Boolean(reportGuid && reportMonth && month !== reportMonth),
        snapshot: JSON.stringify([paymentGuid, month, reportGuid, reportMonth, sourceGuids]),
      };
    },
    // 单月同步选择器，来源清除后可继续手填。
    setAccountMonth(value) {
      this.formData.accountMonth = this.normalizeAccountMonth(value);
      const months = JSON.parse(this.formData.accountMonth || '[]');
      this.accountMonthPick = months.length === 1 ? months[0] : '';
    },
    // 核算月手填：单月包成JSON数组落formData（与库内格式同构）
    onAccountMonthPick(val) {
      this.setAccountMonth(val);
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    isLastPerson(camundaDeploymentId) {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.personShow = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //指定人
    onPersonSelect([personGuid, data]) {
      this.formData.startAssigner = personGuid.join(',');
      if (!this.formData.startAssigner) {
        this.$message.error('请先选择人员!');
        return;
      }
      return this.postFormData(true);
    },
    seeDetail(row) {
      let url = '/settlementDocDetail'
      if(this.formData.isChangeService == 'Y'){
        url = '/settlementBillDetail'
      }
      url += '?guid=' + row.guid;
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: '';
  text-align: center;
  line-height: 37px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 700;
    }

    .form-title-item {
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 600;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      // width: 220px;
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 0px 16px;
    padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    border: 1px solid rgba(217, 217, 217, 1);

    .header-div {
      background: #f2f2f2;
      font-size: 12px;
      color: #909399;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      height: 32px;
      line-height: 32px;
      font-weight: 500;
    }

    .tab-label {
      padding: 0px 10px;
      width: 200px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-top: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 200px);
      height: 32px;
      line-height: 32px;
      border-top: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 10px;

      div:first-child {
        width: 80px;
        background: #fafafa;
        // border-top: 1px solid rgba(229, 229, 229, 1);
        border-right: 1px solid rgba(229, 229, 229, 1);
        font-weight: bold;
      }

      div:last-child {
        padding: 10px 6px;
        width: calc(100% - 80px);

        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    border-left: 1px solid rgba(217, 217, 217, 1);
    border-right: 1px solid rgba(217, 217, 217, 1);
    border-bottom: 1px solid rgba(217, 217, 217, 1);
  }

  .table2 {
    margin: 16px 0px;
  }

  .info-box {
    width: calc(50% - 12px);
  }
}
.search-area .el-col-8{
  justify-content: flex-start;
}
</style>
